import { findVisitorSessionInputs } from '#app/utilities/findVisitorSessionInputs.js';

export const useFirstReferrerUrl = () => {
  /**
   * This value stores the first value of document.referrer that is non-empty.
   */
  return findVisitorSessionInputs()?.firstReferrerUrl ?? null;
};
